import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledListItemProps } from './LogoShowcase.types';

export const StyledImage = styled.img`
  display: block;
  width: auto;
  height: 100%;
`;

export const StyledWrapper = styled.div`
  width: 100%;
`;

export const StyledList = styled.ul`
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: column;
    gap: 30px;

    li {
      margin: 10px 0 0 0;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    gap: 54px;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 72px;
  }
`;

export const StyledListItem = styled.li<IStyledListItemProps>`
  list-style: none;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: 100%;
    height: ${({ imageHeight }) => rem(imageHeight.sm)};
    margin: ${({ theme }) => rem(theme.spacings.m)} 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: calc(100% / ${({ length }) => length});
    height: ${({ imageHeight }) => rem(imageHeight.lg)};
  }
`;
